<template>
    <div class="layer_pop_wrap">
        <div class='layer_pop_dim' style="background: rgba(0, 0, 0, 0);" :style="active? 'display: block;' : 'display: none'">
            <div class="layer_pop sm" :class="active? 'active' : ''" data-role-popup="modal_01" tabindex="0">
                <div class="pop_head">
                    <h2>사전 등록 정보 선택</h2>
                    <button type="button" class="pop_close" @click="close">닫기</button>
                </div>
                <div class="pop_cont">
                    <div class="form_cont">
                        <ul class="inp_column grid-cols-2">
                            <li v-if="getRegistMaterial.registFlag">
                                <div class="tag_button_area" :class="checkDictionaryData.MATERIAL ? 'disabled' : 'materials'">
                                    <button class="tag_button" @click="open('MATERIAL')">
                                        <em class="txt">재료</em>
                                    </button>
                                </div>
                                <div class="text-center label_txt">
                                    <span v-if="checkDictionaryData.MATERIAL">연결가능</span>
                                    <span v-else>
                                        <em>사전 수정 필요</em>
                                    </span>
                                </div>
                            </li>
                            <li v-if="getRegistAnalysis.registFlag">
                                <div class="tag_button_area" :class="checkDictionaryData.PURPOSE ? 'disabled' : 'analysis'">
                                    <button class="tag_button" @click="open('ANALYSIS')">
                                        <em class="txt">분석목적</em>
                                    </button>
                                </div>
                                <div class="text-center label_txt">
                                    <span v-if="checkDictionaryData.PURPOSE">연결가능</span>
                                    <span v-else>
                                        <em>사전 수정 필요</em>
                                    </span>
                                </div>
                            </li>
                            <li v-if="getRegistMeasurement.registTypeError || getRegistAnalysis.registTypeError">
                                <div class="tag_button_area disabled">
                                    <button class="tag_button" @click="open('ERROR')">
                                        <em class="txt">확인필요</em>
                                    </button>
                                </div>
                                <div class="text-center label_txt">
                                    <span>
                                        <em>목적 분류 불일치</em>
                                    </span>
                                </div>
                            </li>
                            <li v-if="getRegistMeasurement.registFlag">
                                <div class="tag_button_area" :class="checkDictionaryData.PURPOSE ? 'disabled' : 'measurement'">
                                    <button class="tag_button" @click="open('MEASUREMENT')">
                                        <em class="txt">측정목적</em>
                                    </button>
                                </div>
                                <div class="text-center label_txt">
                                    <span v-if="checkDictionaryData.PURPOSE">연결가능</span>
                                    <span v-else>
                                        <em>사전 수정 필요</em>
                                    </span>
                                </div>
                            </li>
                            <li v-if="getRegistEquipment.registFlag">
                                <div class="tag_button_area" :class="checkDictionaryData.EQUIPMENT ? 'disabled' : 'equipment'">
                                    <button class="tag_button" @click="open('EQUIPMENT')">
                                        <em class="txt">장비</em>
                                    </button>
                                </div>
                                <div class="text-center label_txt">
                                    <span v-if="checkDictionaryData.EQUIPMENT">연결가능</span>
                                    <span v-else>
                                        <em>사전 수정 필요</em>
                                    </span>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
        <Loading :visible="loading" type="fixed"></Loading>
    </div>
</template>
<script>
    import Loading from '@common/loading.vue'
    const Dictionary = createNamespacedHelpers('Dictionary');
    import {createNamespacedHelpers} from 'vuex';

    export default {
        props: {
            active: {
                type: Boolean,
                default: false,
            }
        },
        components: {
            Loading,  
        },
        watch: {
            async active(bool) {
                if (bool) {
                    await this.init();
                } else {
                    this.callResetLinkNodeFunc(null);
                    this.resetRegistDictionaryData({category: "ALL"});
                    this.$emit("setTargetProtocolTag", true, true);
                }
            },
            async getDictionaryCheckKey(){
                this.loading = true;
                if(this.getRegistMaterial.registFlag){
                    this.checkDictionaryData.MATERIAL = await this.checkDictionary(this.getRegistMaterial);    
                }
                if(this.getRegistAnalysis.registFlag){
                    this.checkDictionaryData.PURPOSE = await this.checkDictionary(this.getRegistAnalysis);
                }
                if(this.getRegistMeasurement.registFlag){
                    this.checkDictionaryData.PURPOSE = await this.checkDictionary(this.getRegistMeasurement);
                }
                if(this.getRegistEquipment.registFlag){
                    this.checkDictionaryData.EQUIPMENT = await this.checkDictionary(this.getRegistEquipment);    
                }
                this.loading = false;
            },
        },
        computed: {
            ...Dictionary.mapGetters(
                [
                    "getRegistMaterial"
                    , "getRegistMeasurement"
                    , "getRegistAnalysis"
                    , "getRegistEquipment"
                    , "getDictionaryCheckKey"
                ]
            ),
        },
        data() {
            return {
                checkDictionaryData : {
                    MATERIAL : false
                    , PURPOSE : false
                    , EQUIPMENT : false
                },
                loading: false,
            }
        },
        methods: {
            ...Dictionary.mapMutations(
                [
                    "setRegistDictionaryPopupOpenFlag"
                    , "setRegistTargetCategory"
                    , "setIsSameDictionary"
                ]
            ),
            ...Dictionary.mapActions(
                [
                    "resetRegistDictionaryData",
                    "callResetLinkNodeFunc",
                ]
            ),
            async open(category) { // MATERIAL ANALYSIS MEASUREMENT EQUIPMENT

                if (category == "ERROR") {
                    window.alert(`<b>목적의 분류가 서로 다릅니다.<br/>수정 후 다시 시도해 주세요.</b><br/><span style="color: red">[측정목적 <> 분석목적]</span>`)
                    return;
                }

                switch (category) {
                    case "MATERIAL":
                        this.callConfirm(this.getRegistMaterial, category);
                        break;
                    case "ANALYSIS":
                        this.callConfirm(this.getRegistAnalysis, category);
                        break;
                    case "MEASUREMENT":
                        this.callConfirm(this.getRegistMeasurement, category);
                        break;
                    case "EQUIPMENT":
                        this.callConfirm(this.getRegistEquipment, category);
                        break;
                }
            },
            async callConfirm(data, category){
                let msg = `<b>이미 연결 가능한 데이터 입니다.</b>`;
                let flag = await this.checkDictionary(data);
                if(flag){
                    window.alert(msg);
                    return;
                }else{
                    this.setIsSameDictionary(false);
                    this.setRegistDictionaryPopupOpenFlag(true);
                    this.setRegistTargetCategory(category);
                }
            },
            async checkDictionary(targetData) {
                let correctionTargetDictionary = await this.$wApi.dictionary.getDictionaryByKey({
                    processId: targetData.correctionTargetId,
                    key: targetData.correctionTargetProcessNode.key,
                    tagId: targetData.correctionTargetProcessNode.tagId,
                });
                let targetDictionary = await this.$wApi.dictionary.getDictionaryByKey({
                    processId: targetData.targetDataId,
                    key: targetData.targetProcessNode.key,
                    tagId: targetData.targetProcessNode.tagId,
                });
                if (correctionTargetDictionary.id && targetDictionary.id) {
                    if (correctionTargetDictionary.id == targetDictionary.id) {
                        return true;
                    } else {
                        // 양쪽 확인.
                        if (targetDictionary.similarTagList.filter(inData => inData.tagId == targetData.correctionTargetProcessNode.tagId).length == 0
                            && correctionTargetDictionary.similarTagList.filter(inData => inData.tagId == targetData.targetProcessNode.tagId).length == 0) {
                            for (const targetTag of targetDictionary.similarTagList) {
                                for (const correctionTag of correctionTargetDictionary.similarTagList) {
                                    if (targetTag.tagId == correctionTag.tagId) {
                                        return true;
                                    }
                                }
                            }
                            return false;
                        } else {
                            return true;
                        }
                    }
                } else if (!correctionTargetDictionary.id && targetDictionary.id) { // 둘 중 한개만 있을때
                    if (targetDictionary.similarTagList.filter(inData => inData.tagId == data.correctionTargetProcessNode.tagId).length == 0) { // tagId가 포함되어 있는지 확인.
                        return false;
                    } else {
                        return true;
                    }
                } else if (correctionTargetDictionary.id && !targetDictionary.id) { // 둘 중 한개만 있을때
                    if (correctionTargetDictionary.similarTagList.filter(inData => inData.tagId == data.targetProcessNode.tagId).length == 0) { // tagId가 포함되어 있는지 확인.
                        return false;
                    } else {
                        return true;
                    }
                } else {
                    return false;
                }
            },
            async init() {
                this.loading = true;
                if(this.getRegistMaterial.registFlag){
                    this.checkDictionaryData.MATERIAL = await this.checkDictionary(this.getRegistMaterial);    
                }
                if(this.getRegistAnalysis.registFlag){
                    this.checkDictionaryData.PURPOSE = await this.checkDictionary(this.getRegistAnalysis);
                }
                if(this.getRegistMeasurement.registFlag){
                    this.checkDictionaryData.PURPOSE = await this.checkDictionary(this.getRegistMeasurement);
                }
                if(this.getRegistEquipment.registFlag){
                    this.checkDictionaryData.EQUIPMENT = await this.checkDictionary(this.getRegistEquipment);    
                }
                this.loading = false;
            },
            close() {
                this.checkDictionaryData = {
                    MATERIAL : false
                    , PURPOSE : false
                    , EQUIPMENT : false
                };
                this.loading = false;
                this.$emit('update:active', false);
            }
        }
    }
</script>
<style lang="scss" scoped>
    .tag_button {
        display: flex;
        min-width: 115px;
        height: 40px;
        align-items: center;
        justify-content: space-between;
        padding: 0 16px;
        border-radius: 5px;
        border: 1px solid #684D92;
        background: #FFF;
        transition: all .3s;
    }
</style>